import styled from 'styled-components';
import { Table } from '@amzn/storm-ui';

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const StyledTable = styled(Table)`
  min-width: 100%;
  border: 0.0625rem solid ${({ theme }) => theme.color.gray[700]};

  && th,
  && td {
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    min-width: 6.25rem;
    max-width: 21.875rem;
    padding: 0.5rem;
    vertical-align: top;
    border: 0.0625rem solid ${({ theme }) => theme.color.gray[700]};
  }
`;

export const StyledTHead = styled.thead`

  && th {
    border: 0.0625rem solid ${({ theme }) => theme.color.gray[700]};
  }
`;


